import type { ReactNode } from 'react';
import { cx } from './cx.ts';

/**
 * The ONE page-title recipe: 20px `title-lg` heading, optional dense
 * sub-line, right-aligned actions. Every routed page renders exactly
 * one of these (DESIGN.md §3 — no more nine-way h1 anarchy).
 */
interface Props {
  readonly title: ReactNode;
  readonly sub?: ReactNode;
  readonly actions?: ReactNode;
  readonly className?: string;
  readonly testId?: string;
}

export function PageHeader({ title, sub, actions, className, testId }: Props): JSX.Element {
  return (
    <header data-testid={testId} className={cx('flex flex-wrap items-baseline gap-x-3 gap-y-1', className)}>
      <h1 className="m-0 text-title-lg text-paper">{title}</h1>
      {sub !== undefined && sub !== null ? <p className="m-0 text-dense text-paper-low">{sub}</p> : null}
      {actions !== undefined && actions !== null ? (
        <div className="ml-auto flex items-center gap-2">{actions}</div>
      ) : null}
    </header>
  );
}
